<template>
<b-modal ref="migrationErrorModal" :visible="migrationErrorWindowVisible" centered title="Wystąpił błąd migracji"
@hidden="hide" ok-only size="xl" scrollable >
   <b-container fluid>
     <b-row class="mb-1">
       <b-col>Status</b-col>
       <b-col cols="10">{{migrationErrorMessage.status}}</b-col> 
      </b-row>

      <b-row class="mb-1">
       <b-col>Treść błędu</b-col>
       <b-col cols="10">{{migrationErrorMessage.error}}</b-col>
      </b-row>

      <b-row class="mb-1">
       <b-col>Plik</b-col>
       <b-col cols="10">{{migrationErrorMessage.errorFilePath}}</b-col>
      </b-row>
      
   </b-container>
   <div slot="modal-footer" class="modal-footer">
        <b-btn variant="btn btn-primary" @click="cancel">Anuluj sesje edycyjną</b-btn>
   </div>
</b-modal>
</template>

<script>
import { WINDOW_MIGRATION_ERROR_HIDE } from "../store/mutations.type";
import { REPORT_CANCEL_DATA_FEED } from "../store/actions.type";
import { mapGetters } from 'vuex';

export default {
  name: "MigrationErrorWindow",
  computed: {
    ...mapGetters(['migrationErrorWindowVisible', 'migrationErrorMessage'])
  },
  methods: {
    hide() {
      this.$store.commit(WINDOW_MIGRATION_ERROR_HIDE);
    },
    cancel() {
      this.$store.dispatch(REPORT_CANCEL_DATA_FEED);
      window.location = window.location.origin + "/admin/#/datafeedrecord/page";
    }
  }
};
</script>
